import { useEffect, useState } from 'react';

export const usePageVisibility = () => {
  const [isPageActive, setIsPageActive] = useState(true);

  useEffect(() => {
    const handleVisibilityChange = () => {
      setIsPageActive(!document.hidden);
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return isPageActive;
};
